<template>
  <v-container fluid class="px-0 py-0">
    <v-tabs v-model="active">
      <v-tab>异常日志</v-tab>
      <v-tab>异常学员</v-tab>
      <v-tab-item>
        <crud :cfg="logCrud" />
      </v-tab-item>
      <v-tab-item>
        <crud v-if="stuCrud" :cfg="stuCrud" />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>
<script>
import { Crud } from "javaee-fre";
const StuELogDetail = () => import("./stu-elog-detail.vue");
export default {
  name: "stu-exception-logs",
  components: {
    crud: Crud,
  },
  watch: {
    active(v) {
      let self = this;
      if (v == 1 && !self.stuCrud) {
        self.stuCrud = {
          url: "/home/admin/sys/stue/stu",
          listItemActions: [
            {
              label: "浏览人脸",
              icon: "face",
              func(cfg) {
                let self = this;
                self.$dialog.crud(`人脸识别 - ${cfg.item.name}`, {
                  url: "/home/admin/sys/stue/face",
                  params: { _aid: cfg.item.id },
                  listItemFilter(i) {
                    let self = this;
                    i.status._component = {
                      name: "crud-list-avatar-item",
                      cfg: {
                        label: i.status.name,
                        url: `${self.$const.baseUrl}/home/admin/sys/stue/face/img/${i.path}?s=100x100`,
                        previewUrl: `${self.$const.baseUrl}/home/admin/sys/stue/face/img/${i.path}`,
                      },
                    };
                  },
                  fullscreen: true,
                });
              },
            },
            {
              label: "从异常用户中移除",
              confirm: "确认将该用户从异常中移除？",
              icon: "delete",
              func(cfg) {
                let self = this;
                self.$axios
                  .get(`/home/admin/sys/stue/stu/flag/${cfg.item.id}/false`)
                  .then(() => {
                    self.refresh();
                  });
              },
            },
          ],
        };
      }
    },
  },
  data() {
    return {
      active: 0,
      logCrud: {
        url: "/home/admin/sys/stue/log",
        detailable: false,
        listActions: [{
          label: '归档', func() {
            let self = this;
            self.$dialog.date('选择归档日期', {}, [{
              label: '确认', color: 'primary', func(date) {
                if (!date) { return }
                self.$axios.get(`/home/admin/sys/stue/log/archive?ts=${date}`).then(r => {
                  if (r.data.status == 'ok') {
                    self.refresh();
                    self.$status('归档成功~', 'success');
                  } else {
                    self.$status(r.data.message || '归档发生错误~', 'error');
                  }
                })
              }
            }]);
          }
        }],
        listItemActions: [
          {
            label: "详情",
            icon: "details",
            func(cfg) {
              this.$dialog.component(`详情 - 学员编号：${cfg.item.accountId}`, StuELogDetail, {
                id: cfg.item.id,
              });
            },
          },
          {
            label: "浏览人脸",
            icon: "face",
            func(cfg) {
              let self = this;
              self.$dialog.crud(`人脸识别 - 学员编号：${cfg.item.accountId}`, {
                url: "/home/admin/sys/stue/face",
                params: { _aid: cfg.item.accountId },
                listItemFilter(i) {
                  let self = this;
                  i.status._component = {
                    name: "crud-list-avatar-item",
                    cfg: {
                      label: i.status.name,
                      url: `${self.$const.baseUrl}/home/admin/sys/stue/face/img/${i.path}?s=100x100`,
                      previewUrl: `${self.$const.baseUrl}/home/admin/sys/stue/face/img/${i.path}`,
                    },
                  };
                },
                fullscreen: true,
              });
            },
          },
          {
            label: "设置为异常用户",
            confirm: "确认将该用户设置为异常用户吗？",
            icon: "warning",
            func(cfg) {
              let self = this;
              self.$axios
                .get(`/home/admin/sys/stue/stu/flag/${cfg.item.accountId}/true`)
                .then(() => {
                  self.$status(
                    "操作成功～已将该学员设置为异常学员。要取消请在异常学员列表中进行取消。",
                    "success"
                  );
                });
            },
          },
          {
            label: "禁用该用户",
            confirm: "确认禁用该用户吗？",
            icon: "clear",
            func(cfg) {
              let self = this;
              self.$axios
                .get(
                  `/home/admin/sys/stue/stu/disable/${cfg.item.accountId}/true`
                )
                .then(() => {
                  self.$status("操作成功～已将该学员禁用。", "success");
                });
            },
          },
        ],
      },
      stuCrud: null,
    };
  },
};
</script>